import { debounce } from "lodash";
import { useCallback, useState } from "react";
import { fetchDropDownData } from "../fetchDropDownData";
import { getDataById } from "../../api/ApiServices";

export const IncoBarTagUtils = () => {
    const [grnNoOptions, setGrnNoOptions] = useState<any[]>([]);
    const [partNoOptions, setpartNoOptions] = useState<any[]>([]);
    const [rackOptions, setRackOptions] = useState<any[]>([]);
    const [partValues, setPartValues] = useState<any>({});
    
    const fetchGrnNoOptions = useCallback(
        debounce((inputValue) => {
            fetchDropDownData({
                endpoint: "/grns/unique",
                searchKey: "grnNo",
                searchTerm: inputValue,
                labelKey: "grnNo",
                valueKey: "_id",
            }).then((data) => {
                const formattedGrnNooptions = data.map((grn:any) => ({
                    label: grn.grnNo,
                    value: grn._id,
                    number: grn.number,
                    date: grn.date,
                    qty: grn.qty
                }));
                
                setGrnNoOptions(formattedGrnNooptions);
            });
        }, 500),
        []
    );

    const fetchPartNoOptions = useCallback(
        debounce((inputValue) => {
            fetchDropDownData({
                endpoint: "/grns",
                searchKey: "grnNo",
                searchTerm: inputValue,
                labelKey: "grnNo",
                valueKey: "_id",
            }).then((data) => {
                console.log(data);
                
                const formattedPartNoOptions = data.map((part:any) => ({
                    label: part?.partId.part.internalPartNo,
                    value: part.partId.part._id,
                    number: part?.number,
                    partName: part.partId.part.partName,
                    model: part.partId.part.modelId?.name,
                    category: part.partId.part.categoryId?.name,
                    uom: part.partId.part.uomId?.name,
                    date: part.date,
                    qty: part.qty,
                    balanceQty: part.balanceQty,
                    poQty: part.poQty,
                    printedQty: part.printedQty, 
                    packingQty: part.partId.part.packingQty
                }));
                
                setpartNoOptions(formattedPartNoOptions);
            });
        }, 500),
        []
    );
    const fetchSearchPartNoOptions = useCallback(
        debounce((inputValue, grnNo) => {
            fetchDropDownData({
                endpoint: "/grns",
                searchKey: `partId.part.internalPartNo`,
                grnNo: grnNo,
                searchTerm: inputValue,
                labelKey: "partId.part.internalPartNo",
                valueKey: "_id",
            }).then((data) => {
                const formattedPartNoOptions = data.map((part:any) => ({
                    label: part?.partId.part.internalPartNo,
                    value: part.partId.part._id,
                    number: part?.number,
                    partName: part.partId.part.partName,
                    model: part.partId.part.modelId?.name,
                    category: part.partId.part.categoryId?.name,
                    uom: part.partId.part.uomId?.name,
                    date: part.date,
                    qty: part.qty,
                    printedQty: part.printedQty,
                    balanceQty: part.balanceQty,
                    poQty: part.poQty,
                    packingQty: part.partId.part.packingQty
                }));
                
                setpartNoOptions(formattedPartNoOptions);
            });
        }, 500),
        []
    );

    const fetchRackOptions = useCallback(
        debounce((inputValue, partId) => {
            if (!partId) return;
            
            fetchDropDownData({
                endpoint: "/itemassignedracks",
                searchKey: "itemId.internalPartNo",
                searchTerm: partId,
                labelKey: "rackId.rackName",
                valueKey: "rackId._id",
            }).then((data) => {
                console.log("rack response: ",data);
                
                const formattedRackOptions = data.map((item: any) => ({
                    label: item.rackId.rackName,
                    value: item.rackId._id
                }));
                
                setRackOptions(formattedRackOptions);
            });
        }, 500),
        []
    );

    return {
        grnNoOptions,
        setGrnNoOptions,
        fetchGrnNoOptions,
        partNoOptions,
        setpartNoOptions,
        fetchPartNoOptions,
        fetchSearchPartNoOptions,
        rackOptions,
        setRackOptions,
        fetchRackOptions,
    };
};